<mat-toolbar class="p-0 mat-elevation-z1 app-toolbar">

    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">

        <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">

            <button mat-icon-button class="navbar-toggle-button"
                    *ngIf="!hiddenNavbar && !rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

            <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

            <div fxLayout="row" fxLayoutAlign="start center">
                <div class="logo ml-16">
                    <img class="logo-icon" style="content: var(--theme-menu-logo)">
                </div>
            </div>

            <div fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
                <div fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center" class="ml-12 bayer-diagonal-bar">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>

                <div fxLayout="row" fxLayoutAlign="start center" class="ml-8">
                    <h1>{{ 'APP.LONG_NAME' | translate}}</h1>
                </div>
            </div>

        </div>

         <language-selector></language-selector>

<!--        <ng-container *ngIf="(currentUser$ | async) as user">-->
<!--            &lt;!&ndash; <mat-form-field appearance="" class="mx-12" fxFlex="1 1 100px">-->
<!--                <mat-label>{{'TOOLBAR.SELECT-COUNTRY' | translate}}</mat-label>-->
<!--                <mat-select  [value]="_tenantSelectorService.selectedTenant|async" (selectionChange)="_tenantSelectorService.selectTenant($event.value)">-->
<!--                    <mat-option *ngFor="let tenant of (_tenantSelectorService.tenants | async)"-->
<!--                                [value]="tenant">-->
<!--                    {{tenant.description}}-->
<!--                    </mat-option>-->
<!--                </mat-select>-->
<!--            </mat-form-field> &ndash;&gt;-->

<!--            <div id="user-profile-container" fxFlex="0 1 110px" class="pwc-orange-300" fxLayout="row" fxLayoutAlign="end">-->
<!--                <button mat-button [matMenuTriggerFor]="userMenu" class="user-button pt-4">-->
<!--                    <div fxLayout="row wrap" fxLayoutAlign="center center">-->
<!--                        <ngx-avatar fxFlex="100%" class="avatar mr-0" size="40" -->
<!--                        [src]="user.urlAvatarInterno" [name]="user.fullUserName"-->
<!--                        [round]="true" fgColor="#2d2d2d" borderColor="#2d2d2d" bgColor="#ffb600">-->
<!--                        </ngx-avatar>-->
<!--                        &lt;!&ndash; <span class="username mr-12" fxHide fxShow.gt-sm>-->
<!--                        {{ user.fullUserName }}-->
<!--                        </span> &ndash;&gt;-->
<!--                        <mat-icon fxFlex="100%" class="s-16 white-text" fxHide.xs>keyboard_arrow_down</mat-icon>-->
<!--                    </div>-->
<!--                </button>-->
<!--            </div>-->
<!--            -->

<!--            <mat-menu #userMenu="matMenu" [overlapTrigger]="false">-->
<!--                &lt;!&ndash; <button mat-menu-item><mat-icon>account_circle</mat-icon><span>My Profile</span></button>-->
<!--                     <button mat-menu-item class=""><mat-icon>mail</mat-icon><span>Inbox</span></button> &ndash;&gt;-->
<!--                <button mat-menu-item class="" (click)="logout()">-->
<!--                    <mat-icon>exit_to_app</mat-icon>-->
<!--                    <span>{{ 'LABELS.LOGOUT' | translate }}</span>-->
<!--                </button>-->
<!--            </mat-menu>-->
<!--        </ng-container>-->

<!--        <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">-->

<!--            <button mat-button [matMenuTriggerFor]="userMenu"-->
<!--                    class="user-button">-->
<!--                <div fxLayout="row" fxLayoutAlign="center center">-->
<!--                    <img class="avatar mr-0 mr-sm-16" src="assets/images/avatars/Velazquez.jpg">-->
<!--                    <span class="username mr-12" fxHide fxShow.gt-sm>Charlie Adams</span>-->
<!--                    <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>-->
<!--                </div>-->
<!--            </button>-->

<!--            <mat-menu #userMenu="matMenu" [overlapTrigger]="false">-->

<!--                <button mat-menu-item>-->
<!--                    <mat-icon>account_circle</mat-icon>-->
<!--                    <span>My Profile</span>-->
<!--                </button>-->

<!--                <button mat-menu-item class="">-->
<!--                    <mat-icon>mail</mat-icon>-->
<!--                    <span>Inbox</span>-->
<!--                </button>-->

<!--                <button mat-menu-item class="">-->
<!--                    <mat-icon>exit_to_app</mat-icon>-->
<!--                    <span>Logout</span>-->
<!--                </button>-->

<!--            </mat-menu>-->

<!--&lt;!&ndash;            <div class="toolbar-separator"></div>&ndash;&gt;-->

<!--&lt;!&ndash;            <fuse-search-bar (input)="search($event)"></fuse-search-bar>&ndash;&gt;-->

            <!-- <div class="toolbar-separator"></div> -->

            <div >

            </div>




<!--            <div class="toolbar-separator" fxHide fxShow.gt-xs></div>-->

<!--&lt;!&ndash;            <button mat-icon-button&ndash;&gt;-->
<!--&lt;!&ndash;                    class="quick-panel-toggle-button"&ndash;&gt;-->
<!--&lt;!&ndash;                    (click)="toggleSidebarOpen('quickPanel')"&ndash;&gt;-->
<!--&lt;!&ndash;                    aria-label="Toggle quick panel">&ndash;&gt;-->
<!--&lt;!&ndash;                <mat-icon class="secondary-text">format_list_bulleted</mat-icon>&ndash;&gt;-->
<!--&lt;!&ndash;            </button>&ndash;&gt;-->

<!--&lt;!&ndash;            <div class="toolbar-separator" *ngIf="!hiddenNavbar && rightNavbar" fxHide fxShow.gt-xs></div>&ndash;&gt;-->

<!--            <button mat-icon-button class="navbar-toggle-button"-->
<!--                    *ngIf="!hiddenNavbar && rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>-->
<!--                <mat-icon class="secondary-text">menu</mat-icon>-->
<!--            </button>-->

<!--        </div>-->

    </div>

</mat-toolbar>
